/**
 * @file PaddleHub 首页支持交流
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useMemo} from 'react';

import TextCardGroup from '../../../../components/text-card/TextCardGroup';
import TextCard from '../../../../components/text-card/TextCard';

import supportCommunicationData from './supportCommunicationData';


const SupportCommunication: React.FC = () => {
    const theList = useMemo(() => {
        return supportCommunicationData;
    }, []);

    return (
        <div className="paddle-hub-sc-wrap">
            <TextCardGroup cols={3}>
                {theList.map(item => (
                    <TextCard
                        key={`${item.title},${item.text}`}
                        title={item.title}
                        text={item.text}
                        link={item.link}
                        onClick={item.onClick}
                        target
                        tagText={item.tagText}
                    />
                ))}
            </TextCardGroup>
        </div>
    );
};

export default SupportCommunication;
